export default {
    "welcome": {
        "title": "Vítejte v ProcrastiQ",
        "subtitle": "Váš produktivní parťák",
        "modal": {
            "title": "Vítejte v ProcrastiQ",
            "headline": "Chytřejší přestávky začínají tady",
            "subheading": "Krátké výzvy, zajímavosti a mozkové jednohubky, které promění pár volných minut v něco smysluplného.",
            "text": "Procrastiq je místo, kde se z obyčejné prokrastinace stává něco smysluplného. Místo nekonečného scrollování sociálních sítí na vás čekají krátké mozkové výzvy které procvičí mysl a možná vás naučí i něco nového.\n\nKaždý potřebuje občas vypnout, odpočinout si a na chvíli utéct od práce. Procrastiq vám pomůže využít tyto drobné přestávky lépe — s trochou zvědavosti, radosti a každodenního tréninku mozku. \n\nMalé výzvy. Velký pokrok.",
            "cta": "Jdeme na to"
        }
    },
    "login": {
        "title": "Přihlášení",
        "email": "E‑mail",
        "password": "Heslo",
        "submit": "Přihlásit se",
        "cancel": "Zrušit",
        "success": "Přihlášení úspěšné",
        "lead": "Vítej zpět — pokračuj ve sérii a stoupej v ligách."
    },
    "auth": {
        "bot_required": "Dokonči prosím bezpečnostní kontrolu."
    },
    "logout": "Odhlásit",
    "register": {
        "title": "Registrace",
        "name": "Jméno",
        "email": "E‑mail",
        "password": "Heslo",
        "submit": "Vytvořit účet",
        "cancel": "Zrušit",
        "success": "Registrace úspěšná",
        "country": "Země",
        "lead": "Založ účet, sbírej XP, odemykej hodnosti a zapoj se do týdenních lig."
    },
    "social": {
        "divider": "Nebo pokračujte přes",
        "signInWith": "Přihlásit se přes {{provider}}",
        "continueWith": "Pokračovat přes {{provider}}",
        "failed": "Přihlášení přes sociální síť selhalo",
        "popup_blocked": "Vyskakovací okno bylo zablokováno. Povolte pop-up okna a zkuste to znovu.",
        "cancelled": "Přihlášení bylo zrušeno."
    },
    "common": {
        "cancel": "Zrušit",
        "saving": "Ukládání...",
        "unknown_error": "Neznámá chyba",
        "select_country": "Vyberte zemi",
        "select_option": "Vyberte možnost",
        "search": "Hledat…",
        "no_options": "Žádné možnosti",
        "country": "Země"
    },
    "language": {
        "page_language": "Jazyk stránek",
        "switch_to": "Přepnout na {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Používáme cookies pro analytiku (Google Analytics), abychom mohli Procrastiq zlepšovat.",
        "privacy_link": "Ochrana soukromí",
        "accept": "Souhlasím",
        "reject": "Odmítnout"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "O nás",
                "mission": "Poslání",
                "progression": "XP, úrovně a ligy",
                "creator_progression": "Tvůrčí XP a hodnosti",
                "contact": "Kontaktujte nás"
            },
            "leaderboards": {
                "title": "Žebříčky",
                "players": "Členové",
                "creators": "Přispěvatelé"
            },
            "legal": {
                "title": "Soukromí a podmínky",
                "community": "Zásady komunity",
                "terms": "Podmínky služby",
                "privacy": "Ochrana soukromí"
            },
            "social": {
                "title": "Sociální sítě",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Poslání",
            "content": "ProcrastiQ proměňuje malé přestávky ve smysluplné chvíle — mozkové jednohubky, hádanky a mindful pauzy, které baví a stimulují vaši mysl.\n\nVěříme, že prokrastinace nemusí být ztracený čas. Každý si zaslouží chvíli na odpočinek a my pomáháme, aby tyto chvíle byly pozitivní, zvídavé a zábavné."
        },
        "contact": {
            "title": "Kontaktujte nás",
            "content": "Máte dotaz, nápad na zlepšení nebo jste narazili na něco, co nefunguje tak, jak má? Ozvěte se nám — každá zpětná vazba nám pomáhá Procrastiq dál zlepšovat.\n\nNapsat nám můžete na:\n\nhello@procrastiq.com\n\nRádi si přečteme také vaše návrhy na nový obsah, funkce nebo témata, která byste na Procrastiq chtěli vidět."
        },
        "community": {
            "title": "Zásady komunity",
            "content": "ProcrastiQ je přívětivé místo pro zvídavé lidi. Buďte respektující, laskaví a konstruktivní ve svých interakcích.\n\nNezveřejňujte škodlivý, urážlivý nebo spamový obsah. Nahlaste cokoli, co sem nepatří. Společně udržíme toto místo pozitivní pro učení a chytré přestávky."
        },
        "terms": {
            "title": "Podmínky služby",
            "content": "**Poslední aktualizace: 7. září 2026**\n\nPoužíváním služby Procrastiq souhlasíte s těmito podmínkami. Pokud s nimi nesouhlasíte, službu prosím nepoužívejte.\n\n## 1. O službě Procrastiq\n\nProcrastiq je online platforma zaměřená na vzdělávání, kvízy, hádanky a další interaktivní obsah.\n\nObsah služby slouží především pro vzdělávání a zábavu. Není určen jako odborné, právní, zdravotní, finanční ani jiné profesionální poradenství.\n\n## 2. Uživatelský účet\n\nNěkteré funkce Procrastiq mohou vyžadovat vytvoření uživatelského účtu.\n\nUživatel odpovídá za správnost údajů uvedených ve svém účtu a za zabezpečení svých přihlašovacích údajů.\n\nÚčet nesmí být používán k porušování práv jiných osob, zákonů ani těchto podmínek.\n\n## 3. Pravidla používání\n\nPři používání Procrastiq není dovoleno zejména:\n\n* zveřejňovat nezákonný, podvodný, nenávistný nebo jinak závadný obsah,\n* porušovat autorská nebo jiná práva třetích osob,\n* obtěžovat ostatní uživatele,\n* pokoušet se narušit zabezpečení nebo fungování služby,\n* automatizovaně získávat obsah nebo data způsobem, který nepovolujeme,\n* zneužívat systém hodnocení, XP, žebříčky nebo jiné herní mechanismy.\n\n## 4. Uživatelský obsah\n\nUživatelé mohou mít možnost vytvářet nebo zasílat vlastní obsah, například kvízy, otázky, komentáře nebo jiné příspěvky.\n\nOdesláním obsahu potvrzujete, že máte právo jej zveřejnit.\n\nAutorovi zůstávají práva k jeho obsahu. Zároveň nám poskytuje nevýhradní oprávnění tento obsah ukládat, zobrazovat, technicky upravovat a zpřístupňovat v rámci Procrastiq v rozsahu potřebném pro provoz služby.\n\n## 5. Moderace obsahu\n\nUživatelský obsah můžeme kontrolovat a v případě porušení těchto podmínek nebo platných právních předpisů jej odmítnout, skrýt nebo odstranit.\n\nV závažných nebo opakovaných případech můžeme omezit nebo zrušit uživatelský účet.\n\nPokud je to vzhledem k okolnostem možné a vyžadované právními předpisy, uživatele o důvodu takového rozhodnutí informujeme.\n\n## 6. Obsah Procrastiq\n\nObsah publikovaný přímo společností Procrastiq může obsahovat chyby nebo nepřesnosti. Přestože se snažíme informace kontrolovat a průběžně zlepšovat, nemůžeme zaručit jejich úplnost nebo bezchybnost.\n\nKvízy a další vzdělávací obsah mají především informační a zábavní charakter.\n\n## 7. Dostupnost služby\n\nSnažíme se udržovat Procrastiq dostupný a funkční, nemůžeme však zaručit nepřetržitý nebo bezchybný provoz.\n\nSlužbu můžeme průběžně měnit, rozšiřovat nebo některé její části ukončit.\n\n## 8. Odpovědnost\n\nV rozsahu povoleném platnými právními předpisy neneseme odpovědnost za škody vzniklé v důsledku nesprávného použití služby nebo spoléhání se na obsah, který má pouze informační či vzdělávací charakter.\n\nTím nejsou dotčena práva uživatelů, která nelze podle platných právních předpisů omezit.\n\n## 9. Ochrana osobních údajů\n\nInformace o tom, jak zpracováváme osobní údaje, naleznete v našich [Zásadách ochrany osobních údajů](/legal/privacy).\n\n## 10. Změny podmínek\n\nTyto podmínky můžeme čas od času aktualizovat například kvůli změnám služby, právních předpisů nebo způsobu fungování Procrastiq.\n\nDatum poslední aktualizace bude vždy uvedeno v horní části této stránky. O významných změnách můžeme uživatele informovat také přímo prostřednictvím služby nebo e-mailem.\n\n## 11. Kontakt\n\nMáte-li otázky týkající se těchto podmínek, můžete nás kontaktovat na:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Ochrana soukromí",
            "content": "**Poslední aktualizace: 7. září 2026**\n\nVaše soukromí bereme vážně. Níže vysvětlujeme, jaké osobní údaje při používání Procrastiq zpracováváme, proč je potřebujeme a jaká máte práva.\n\n## 1. Kdo údaje zpracovává\n\nSprávcem osobních údajů je:\n\n**Michal Orlík**\nfyzická osoba\n\nKontakt pro otázky týkající se ochrany osobních údajů:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Jaké údaje zpracováváme\n\nV závislosti na tom, jak Procrastiq používáte, můžeme zpracovávat zejména:\n\n* údaje o vašem účtu, například jméno, uživatelské jméno a e-mailovou adresu,\n* údaje získané při přihlášení prostřednictvím externí služby, například Google,\n* informace o používání služby, například zobrazený obsah, výsledky kvízů, získané XP, streaky, reakce, záložky a aktivitu ve feedu,\n* obsah, který sami vytvoříte nebo odešlete,\n* technické údaje, například IP adresu, typ zařízení, prohlížeč a informace potřebné pro zabezpečení a správné fungování služby.\n\n## 3. Proč údaje používáme\n\nOsobní údaje používáme zejména k tomu, abychom:\n\n* mohli vytvořit a spravovat váš účet,\n* mohli poskytovat funkce Procrastiq,\n* ukládali váš postup, výsledky, XP a další aktivitu,\n* přizpůsobovali obsah a doporučení,\n* chránili službu před zneužitím,\n* řešili chyby a technické problémy,\n* komunikovali s vámi,\n* analyzovali a zlepšovali fungování služby.\n\n## 4. Právní základ zpracování\n\nÚdaje zpracováváme podle konkrétního účelu zejména:\n\n* protože jsou nezbytné pro poskytování služby,\n* na základě našeho oprávněného zájmu na zabezpečení a zlepšování Procrastiq,\n* na základě vašeho souhlasu tam, kde je souhlas vyžadován,\n* případně z důvodu plnění právních povinností.\n\nPokud je zpracování založeno na souhlasu, můžete jej kdykoli odvolat.\n\n## 5. Komu mohou být údaje předány\n\nVaše osobní údaje neprodáváme.\n\nPro provoz služby však můžeme využívat externí poskytovatele, například pro:\n\n* hosting a infrastrukturu,\n* přihlašování uživatelů,\n* odesílání e-mailů a notifikací,\n* analytiku a diagnostiku chyb.\n\nTito poskytovatelé mohou údaje zpracovávat pouze v rozsahu potřebném k poskytování jejich služeb.\n\n## 6. Jak dlouho údaje uchováváme\n\nÚdaje spojené s vaším účtem zpravidla uchováváme po dobu existence účtu a následně po dobu nezbytnou pro splnění právních povinností nebo ochranu našich oprávněných zájmů.\n\nTechnické a analytické údaje uchováváme pouze po dobu potřebnou pro jejich účel.\n\n## 7. Vaše práva\n\nV souvislosti se zpracováním osobních údajů máte podle okolností právo:\n\n* získat informace o tom, jaké údaje o vás zpracováváme,\n* požádat o opravu nepřesných údajů,\n* požádat o výmaz údajů,\n* požádat o omezení jejich zpracování,\n* vznést námitku proti některým způsobům zpracování,\n* získat své údaje v přenositelném formátu,\n* odvolat udělený souhlas.\n\nPožadavek můžete zaslat na:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nNa žádosti odpovídáme v souladu s platnými právními předpisy.\n\n## 8. Smazání účtu\n\nPokud služba umožňuje smazání účtu, můžete o jeho odstranění požádat přímo v nastavení účtu nebo nás kontaktovat na **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nSmazáním účtu odstraníme nebo anonymizujeme osobní údaje, které již nemusíme uchovávat z právních nebo bezpečnostních důvodů.\n\n## 9. Cookies a podobné technologie\n\nProcrastiq může používat cookies a podobné technologie potřebné pro přihlášení, zabezpečení, ukládání nastavení a případně analytiku.\n\nPodrobnější informace o cookies mohou být uvedeny v samostatných zásadách používání cookies.\n\n## 10. Zabezpečení\n\nPoužíváme přiměřená technická a organizační opatření k ochraně osobních údajů před neoprávněným přístupem, ztrátou nebo zneužitím.\n\nŽádný systém však nelze považovat za absolutně bezpečný.\n\n## 11. Stížnost\n\nPokud máte za to, že s vašimi osobními údaji nakládáme v rozporu s právními předpisy, můžete se obrátit také na příslušný dozorový úřad.\n\nV České republice je jím **Úřad pro ochranu osobních údajů**.\n\n## 12. Změny těchto zásad\n\nTyto zásady můžeme čas od času aktualizovat, například v souvislosti s novými funkcemi nebo změnami právních předpisů.\n\nDatum poslední aktualizace vždy uvedeme v horní části této stránky."
        },
        "progression": {
            "title": "XP, úrovně a ligy",
            "content": "ProcrastiQ odměňuje zvědavost. Odpovídejte na kvízy, budujte sérii a postupujte od lehké zábavy až k týdenní soutěži.\n\n## Zkušenostní body (XP)\n\nTrvalé XP získáváte za dobrou hru — například správné odpovědi, bonus za první pokus, těžší otázky, procvičení chyb a denní cíle. Trvalé XP se nikdy neresetuje a vždy počítá do vaší úrovně.\n\nExistuje také soutěžní XP jen pro týdenní ligy. Soutěžní XP má během dne klesající výnosy: dřívější XP se počítá naplno, pozdější méně. Díky tomu je soutěž férovější, i když někdo hraje celý den.\n\n## Úrovně\n\nÚroveň vychází z celkového trvalého XP. Každá další úroveň potřebuje o něco víc XP než předchozí, aby byl postup pořád smysluplný.\n\nV profilu vidíte, kolik XP máte v aktuální úrovni a kolik zbývá do další.\n\n## Hodnosti\n\nHodnosti jsou tituly odemčené podle úrovně. Jsou odznakem vašeho pokroku — odděleně od týdenních ligových úrovní.\n\n- Úroveň 1 — Zvědavá mysl\n- Úroveň 3 — Průzkumník\n- Úroveň 5 — Badatel\n- Úroveň 8 — Řešitel\n- Úroveň 12 — Analytik\n- Úroveň 18 — Logik\n- Úroveň 25 — Stratég\n- Úroveň 35 — Polyhistor\n- Úroveň 50 — Génius\n- Úroveň 70 — Mistr poznání\n- Úroveň 100 — Legenda Procrastiq\n\n## Týdenní ligy\n\nLigy jsou týdenní soutěž s ostatními hráči ve skupinách asi po 20.\n\nÚrovně od nejnižší po nejvyšší:\n\n- Železná\n- Bronzová\n- Stříbrná\n- Zlatá\n- Platinová\n- Diamantová\n- Mistrovská\n- Legendární\n\nKaždý týden soutěžíte v rámci své skupiny o soutěžní XP. Na konci týdne zhruba nejlepší hráči postoupí o úroveň výš a nejhorší sestoupí. Ostatní zůstávají.\n\nNemusíte čekat na pondělní reset. Jakmile splníte podmínky, dostanete se do otevřené skupiny hned — nebo se pro vás vytvoří nová.\n\nPro odemčení lig obvykle potřebujete:\n\n- alespoň 100 trvalého XP\n- alespoň 10 dokončených aktivit\n- aktivitu alespoň ve 2 různých dnech\n- zapnuté zobrazování v žebříčcích u profilu\n\nKdykoli otevřete Žebříček nebo panel statistik a uvidíte svou ligu, pozici a skupinu."
        },
        "creator_progression": {
            "title": "Tvůrčí XP a hodnosti",
            "content": "Tvorba obsahu na ProcrastiQ má vlastní postup — úplně oddělený od hráčského XP, úrovní a týdenních lig.\n\nKdyž lidem chutnají vaše kvízy a mozkové jednohubky, získáváte tvůrčí XP (CXP). CXP odemyká tvůrčí hodnosti a řadí vás na žebříčky Přispěvatelů.\n\n## Dva nezávislé systémy\n\n- Hráčský postup — XP za hraní, úrovně, tituly, týdenní ligy\n- Tvůrčí postup — CXP za kvalitní příspěvky, tvůrčí hodnosti, žebříčky Přispěvatelů\n\nHraní nezvyšuje tvůrčí hodnost. Tvorba nezvyšuje hráčskou úroveň. Oba tracky můžete růst najednou.\n\n## Jak se získává tvůrčí XP\n\nCXP se uděluje za schválené příspěvky a za engagement na tomto obsahu — ne za počet odeslaných draftů.\n\nTypické odměny:\n\n- Schválený obsah — +20 CXP (jednou za položku)\n- Každých 10 dokončení vašeho obsahu — +2 CXP\n- Každých 10 lajků — +5 CXP\n- Každých 10 záložek — +2 CXP\n\nZobrazení a další statistiky se na tvůrčím profilu sledují, ale CXP dávají jen odměny výše. Hodnoty se mohou časem upravit.\n\n## Tvůrčí hodnosti\n\nHodnost vychází z celkového CXP. Prahy rostou zhruba exponenciálně — začátek je rychlý, vyšší hodnosti zůstávají výzvou.\n\n- 0 CXP — Přispěvatel\n- 50 CXP — Tvůrce\n- 150 CXP — Autor\n- 400 CXP — Expert\n- 1 000 CXP — Mentor\n- 2 500 CXP — Mistr tvůrce\n- 6 000 CXP — Procrastiq Mudrc\n\nV profilu vidíte aktuální hodnost, CXP a postup k další hodnosti.\n\n## Žebříčky Přispěvatelů\n\nTvůrci se řadí podle tvůrčího XP, ne podle počtu odeslaných položek.\n\n- Týdenní — CXP získané tento týden\n- Měsíční — CXP získané tento měsíc\n- Celkově — celkové CXP\n\nOtevřete Žebříčky a přepněte na Přispěvatele, abyste viděli, kdo stoupá."
        }
    },
    "account": {
        "profile_picture": "Profilová fotografie",
        "save_changes": "Uložit změny",
        "update_success": "Profil byl úspěšně aktualizován",
        "update_failed": "Nepodařilo se aktualizovat profil",
        "country": "Země",
        "avatar": {
            "upload_label": "Nahrát avatar",
            "upload_success": "Avatar byl úspěšně nahrán",
            "upload_failed": "Nahrávání avataru se nezdařilo",
            "delete_confirm": "Opravdu chcete smazat svůj avatar?",
            "delete_success": "Avatar byl úspěšně smazán",
            "delete_failed": "Smazání avataru se nezdařilo"
        },
        "password": {
            "set_optional": "Nastavit heslo (volitelné)",
            "change_optional": "Změnit heslo (volitelné)",
            "oauth_info": "Přihlásili jste se přes {{method}}. Volitelně si můžete nastavit heslo pro přihlášení e‑mailem/heslem.",
            "current": "Současné heslo",
            "current_placeholder": "Zadejte současné heslo",
            "current_required": "Pro změnu hesla je vyžadováno současné heslo",
            "new": "Nové heslo",
            "set_placeholder": "Nastavte heslo",
            "leave_blank_placeholder": "Ponechte prázdné pro zachování",
            "confirm": "Potvrzení nového hesla",
            "confirm_placeholder": "Potvrďte nové heslo",
            "mismatch": "Nová hesla se neshodují"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "focus": "Fokus",
            "reflex": "Reflex",
            "memory": "Paměť",
            "sequence": "Sekvence",
            "switch": "Přepínač",
            "rotate": "Rotace",
            "reason": "Úvaha"
        },
        "actions": {
            "check": "Zkontrolovat",
            "continue": "Pokračovat",
            "start": "Start"
        },
        "countdown": {
            "go": "Teď!"
        },
        "intro": {
            "what": "Co to je",
            "why": "Proč to nabízíme",
            "how": "Co dělat"
        },
        "focus": {
            "start_hint": "Zapamatuj si označené cíle a sleduj je v pohybu. Pak je znovu označ.",
            "hint_preview": "Zapamatuj si těchto {{n}} cílů.",
            "hint_track": "Sleduj je…",
            "hint_select": "Klepni na cíle, které jsi sledoval/a.",
            "arena": "Herní plocha",
            "object": "Objekt {{n}}"
        },
        "reflex": {
            "progress": "{{current}} / {{total}}",
            "tap": "Reakční plocha",
            "go": "KLEPNI",
            "nogo": "ČEKEJ",
            "rules": {
                "skip_red": {
                    "hint": "Klepni na zelenou nebo modrou. Na červenou ne.",
                    "countdown_hint": "Připrav se — klepni na zelenou nebo modrou, červenou přeskoč."
                },
                "skip_green": {
                    "hint": "Klepni na červenou nebo modrou. Na zelenou ne.",
                    "countdown_hint": "Připrav se — klepni na červenou nebo modrou, zelenou přeskoč."
                },
                "skip_blue": {
                    "hint": "Klepni na zelenou nebo červenou. Na modrou ne.",
                    "countdown_hint": "Připrav se — klepni na zelenou nebo červenou, modrou přeskoč."
                }
            }
        },
        "memory": {
            "countdown_hint": "Připrav se — zapamatuj si vzor a pak změny.",
            "countdown_hint_stream": "Připrav se — pamatuj si jen poslední symboly.",
            "hint_preview": "Zapamatuj si, která pole jsou zapnutá.",
            "hint_on": "Pole {{n}} ZAP",
            "hint_off": "Pole {{n}} VYP",
            "hint_final": "Obnov finální vzor.",
            "hint_stream": "Sleduj symboly…",
            "hint_last_n": "Klepni na posledních {{n}} symbolů v pořadí.",
            "intro": {
                "tagline": "Krátce si něco zapamatuj a potom to použij.",
                "what": "Cvičení pracovní paměti: zapamatuj si vzor nebo poslední symboly a pak je obnov.",
                "why": "Pracovní paměť podporuje soustředění a učení — krátký trénink ji udržuje bez dlouhých drilů.",
                "how": "Pozorně sleduj, počkej na změny nebo proud symbolů a pak klepni odpověď. Přesnost je důležitější než rychlost."
            }
        },
        "sequence": {
            "countdown_hint": "Připrav se — sekvence za chvíli začne.",
            "hint_watch_forward": "Sleduj sekvenci.",
            "hint_watch_reverse": "Sleduj — budeš ji opakovat pozpátku.",
            "hint_watch_filter": "Sleduj — pamatuj si jen modré.",
            "hint_watch_interference": "Sleduj pozorně.",
            "hint_distract": "Drž to v paměti…",
            "hint_input_forward": "Zopakuj sekvenci.",
            "hint_input_reverse": "Zadej ji pozpátku.",
            "hint_input_filter": "Zadej jen modré položky.",
            "hint_input_interference": "Teď sekvenci zopakuj.",
            "progress": "{{current}} / {{total}}",
            "pad": "Pole {{n}}",
            "pads": "Pole sekvence"
        },
        "switch": {
            "start_hint": "Podle aktuálního pravidla (barva nebo tvar) vyber správnou odpověď. Pravidlo se může změnit.",
            "rule": "Pravidlo: {{rule}}",
            "progress": "{{current}} / {{total}}",
            "rules": {
                "color": "BARVA",
                "shape": "TVAR"
            },
            "options": {
                "red": "Červená",
                "blue": "Modrá",
                "green": "Zelená",
                "circle": "Kruh",
                "square": "Čtverec",
                "triangle": "Trojúhelník"
            }
        },
        "rotate": {
            "start_hint": "Je pravý tvar stejný jako levý, jen otočený? Ano, nebo ne.",
            "hint": "Stejný tvar, jen otočený?",
            "progress": "{{current}} / {{total}}",
            "reference": "Referenční tvar",
            "comparison": "Porovnávaný tvar",
            "yes": "Ano",
            "no": "Ne"
        },
        "reason": {
            "progress": "{{current}} / {{total}}",
            "modes": {
                "operators": "Operátory",
                "running_total": "Průběžný součet",
                "number_relations": "Vztahy",
                "balance": "Váhy"
            },
            "start_hints": {
                "operators": "Vyber operátory, které rovnici správně doplní.",
                "running_total": "Sčítej čísla, která se postupně objeví. Na konci zvol celkový součet.",
                "number_relations": "Podle zadaného pravidla vyberte správný výsledek.",
                "balance": "Z rovnic odvoď hodnoty tvarů a dopočítej chybějící výsledek."
            },
            "operators": {
                "prompt": "Vyber správnou rovnici."
            },
            "running_total": {
                "progress": "Sekvence {{current}} / {{total}}",
                "watch": "Sčítej čísla, která se objeví.",
                "ask": "Jaký je součet všech zobrazených čísel?"
            },
            "relations": {
                "square": "Které číslo je druhá mocnina {{n}}?",
                "square_root": "Které číslo je odmocnina z {{n}}?",
                "double": "Které číslo je dvojnásobek {{n}}?",
                "half": "Které číslo je polovina z {{n}}?",
                "triple": "Které číslo je trojnásobek {{n}}?",
                "one_third": "Které číslo je třetina z {{n}}?",
                "next_multiple": "Které číslo je další násobek {{step}} po {{n}}?",
                "simple_difference": "Které číslo je o {{step}} menší než {{n}}?"
            },
            "balance": {
                "prompt": "Jaká je chybějící hodnota?"
            }
        },
        "result": {
            "success": "Super!",
            "finished": "Hotovo",
            "fail": "✗ Špatně.",
            "score": "Skóre {{n}}",
            "accuracy": "Přesnost {{n}} %",
            "level": "Úroveň {{n}}",
            "personal_best": "Nový osobní rekord",
            "level_unlocked": "Odemčena úroveň {{n}}",
            "level_adjusted": "Obtížnost upravena"
        }
    },
    "pause": {
        "label": "Pauza",
        "start": "Začít",
        "skip": "Přeskočit",
        "skip_step": "Přeskočit tento krok",
        "continue": "Pokračovat",
        "why_this_works": "Proč to funguje",
        "research": "Zobrazit výzkum",
        "intro": {
            "what": "O co jde",
            "why": "Proč to nabízíme",
            "how": "Co dělat"
        },
        "protocols": {
            "paced_breathing": {
                "name": "Zpomalení",
                "tagline": "Klidný, pravidelný dechový rytmus.",
                "what": "Vedené dýchání asi šestkrát za minutu — pět sekund nádech, pět sekund výdech.",
                "why": "Krátké pomalé dýchání se zkoumalo v souvislosti se zklidněním nálady a fyziologie po soustředěné práci.",
                "how": "Sleduj kruh a text na obrazovce. Dýchej pohodlně, bez nucení.",
                "safety": "Dýchej pohodlně a nikdy dech nenuť. Pokud se ti zatočí hlava nebo je ti nepříjemně, zastav se a vrať se k běžnému dýchání."
            },
            "cyclic_sigh": {
                "name": "Hluboký reset",
                "tagline": "Dvojitý nádech a dlouhý, klidný výdech.",
                "what": "Jeden cyklus: pomalý nádech, kratší dodechnutí a dlouhý pohodlný výdech — bez zadržení dechu.",
                "why": "Pětiminutové cyklické povzdechy byly zkoumány v souvislosti s náladou a fyziologickým zklidněním.",
                "how": "Sleduj pokyny: nadechni se, ještě trochu, pak pomalu vydechuj. Zůstaň u jemného dechu.",
                "safety": "Dýchej pohodlně a nikdy dech nenuť. Pokud se ti zatočí hlava nebo je ti nepříjemně, zastav se a vrať se k běžnému dýchání."
            },
            "progressive_release": {
                "name": "Uvolnění",
                "tagline": "Jemné napětí a kontrast při puštění.",
                "what": "Krátké uvolnění svalů: jemné napětí a delší klidné puštění.",
                "why": "Progresivní svalová relaxace je obecná technika na uvolnění napětí. Konkrétní délky 2 a 4 minuty jsou praktické zkratky, ne klinicky ověřený protokol.",
                "how": "Pět sekund jemně napni uvedenou oblast, pak uvolni a vnímej rozdíl. Dýchej přirozeně. Jakýkoli krok můžeš přeskočit.",
                "safety": "Používej jen jemné napětí. Přeskoč jakoukoli oblast, která bolí nebo je nepříjemná."
            },
            "nature_restore": {
                "name": "Obnova",
                "tagline": "Klidný pohled na přírodu — bez úkolů.",
                "what": "Nenáročná pauza s klidným přírodním videem.",
                "why": "Krátké přírodní mikropauzy a digitální kontakt s přírodou se zkoumaly v souvislosti s obnovou pozornosti.",
                "how": "Jen se dívej. Žádné otázky ani úkoly — nech oči spočinout na scéně.",
                "safety": "Pokud další obrazovka není pauza, kterou potřebuješ, přeskoč to a podívej se pryč od zařízení."
            }
        },
        "duration": {
            "prompt": "Kolik máš času?",
            "short": "Krátká",
            "recommended": "Doporučená",
            "seconds": "{{n}} s",
            "minutes": "{{n}} min",
            "groups": "{{n}} svalových skupin"
        },
        "continue_to_duration": "Zvolit délku",
        "breathing": {
            "inhale": "Nádech",
            "exhale": "Výdech"
        },
        "cyclic": {
            "inhale": "Nádech",
            "topup": "Ještě trochu",
            "exhale": "Pomalu vydechuj"
        },
        "release": {
            "phase": {
                "tense": "NAPNI",
                "relax": "UVOLNI A VNÍMEJ"
            },
            "instructions": {
                "hands": {
                    "tense": "Jemně napni ruce. Dýchej přirozeně.",
                    "relax": "Povol ruce a vnímej, jak napětí postupně odchází."
                },
                "forearms": {
                    "tense": "Jemně napni předloktí. Dýchej přirozeně.",
                    "relax": "Povol předloktí a vnímej, jak napětí postupně odchází."
                },
                "hands_forearms": {
                    "tense": "Jemně napni ruce a předloktí. Dýchej přirozeně.",
                    "relax": "Povol ruce a předloktí a vnímej, jak napětí postupně odchází."
                },
                "shoulders": {
                    "tense": "Jemně napni svaly ramen. Dýchej přirozeně.",
                    "relax": "Povol ramena a vnímej, jak napětí postupně odchází."
                },
                "shoulders_back": {
                    "tense": "Jemně napni ramena a horní záda. Dýchej přirozeně.",
                    "relax": "Povol ramena a záda a vnímej, jak napětí postupně odchází."
                },
                "face_jaw": {
                    "tense": "Jemně napni obličej a čelist. Dýchej přirozeně.",
                    "relax": "Povol obličej a čelist a vnímej, jak napětí postupně odchází."
                },
                "upper_back": {
                    "tense": "Jemně napni horní záda. Dýchej přirozeně.",
                    "relax": "Povol horní záda a vnímej, jak napětí postupně odchází."
                },
                "legs_feet": {
                    "tense": "Jemně napni nohy a chodidla. Dýchej přirozeně.",
                    "relax": "Povol nohy a chodidla a vnímej, jak napětí postupně odchází."
                }
            },
            "steps": {
                "hands": "Ruce",
                "forearms": "Předloktí",
                "hands_forearms": "Ruce a předloktí",
                "shoulders": "Ramena",
                "shoulders_back": "Ramena a horní záda",
                "face": "Obličej a čelist",
                "face_jaw": "Obličej a čelist",
                "upper_back": "Horní záda",
                "back": "Záda",
                "belly": "Břicho",
                "legs": "Nohy",
                "feet": "Chodidla",
                "legs_feet": "Nohy a chodidla",
                "arms": "Paže"
            }
        },
        "nature": {
            "hint": "Nech oči spočinout na scéně.",
            "unavailable": "Zatím není k dispozici žádný přírodní záběr.",
            "scenes": {
                "scene_01": "Klidná přírodní scéna",
                "scene_02": "Klidná přírodní scéna",
                "scene_03": "Klidná přírodní scéna",
                "scene_04": "Klidná přírodní scéna",
                "scene_05": "Klidná přírodní scéna",
                "scene_06": "Klidná přírodní scéna",
                "scene_07": "Klidná přírodní scéna",
                "scene_08": "Klidná přírodní scéna"
            }
        },
        "complete": {
            "title": "Hotovo"
        },
        "feedback": {
            "prompt": "Pomohlo to?",
            "yes": "Ano",
            "a_little": "Trochu",
            "no": "Spíš ne"
        }
    },
    "content": {
        "loading": "Načítání...",
        "no_content": "Zatím žádný obsah.",
        "feed_exhausted_tag": "Pro tento štítek jste si již vše zodpověděli",
        "feed_exhausted_category": "Pro tuto kategorii jste si již vše zodpověděli",
        "browse_feed": "Prohlédnout obsah",
        "back_to_feed": "← Zpět na přehled",
        "back": "← Zpět",
        "content_not_found": "Obsah nenalezen",
        "failed_load": "Nepodařilo se načíst obsah",
        "failed_load_more": "Nepodařilo se načíst další",
        "list": {
            "showing": "Zobrazeno {{count}} z {{total}}",
            "load_more": "Načíst další"
        },
        "answer": {
            "your_answer": "Vaše odpověď...",
            "your_result_or_answer": "Váš výsledek nebo odpověď...",
            "select_or_type": "Vyberte odpověď...",
            "fill_in_blank": "Doplňte chybějící slovo...",
            "your_answer_flip": "Vaše odpověď (nebo otočte pro kontrolu)...",
            "reveal_answer": "Zobrazit odpověď",
            "self_check_prompt": "Věděli jste to?",
            "knew_it": "Věděl/a jsem",
            "need_practice": "Potřebuji procvičit",
            "check": "Zkontrolovat",
            "completed": "Hotovo",
            "completing": "Ukládám...",
            "skip": "Přeskočit",
            "next": "Další",
            "checking": "Kontroluji...",
            "correct": "✓ Správně!",
            "not_quite": "✗ Skoro.",
            "correct_answer": "Správná odpověď: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Přihlaste se pro lajk/dislajk",
            "bookmark": "Uložit",
            "remove_bookmark": "Odebrat záložku",
            "save_for_later": "Uložit na později",
            "saved": "Uloženo",
            "share": "Sdílet",
            "link_copied": "Odkaz zkopírován do schránky",
            "share_failed": "Kvíz se nepodařilo sdílet",
            "completions": "Dokončeno: {{count}}",
            "aria_like": "Lajk",
            "aria_dislike": "Dislajk"
        },
        "admin": {
            "edit": "Upravit",
            "delete": "Smazat",
            "stats": "Statistiky",
            "stats_title": "Statistiky obsahu",
            "delete_confirm": "Smazat „{{title}}“?",
            "deleted": "Obsah smazán",
            "delete_failed": "Nepodařilo se smazat obsah",
            "load_failed": "Nepodařilo se načíst obsah",
            "id": "ID",
            "slug": "Slug",
            "status": "Stav",
            "locale": "Jazyk",
            "likes": "Lajky",
            "dislikes": "Dislajky",
            "completions": "Dokončení",
            "open_in_admin": "Otevřít v administraci"
        },
        "difficulty": {
            "label": "Obtížnost: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Obtížnost {{value}} z {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Přihlaste se pro odpověď na tuto otázku.",
            "duration": "Trvání: {{minutes}} min",
            "phase": "Fáze {{number}}"
        },
        "list_item": {
            "completions": "{{count}} dokončení",
            "completions_label": "Dokončení: {{count}}"
        },
        "feed": {
            "success": "Správně! 🎉",
            "skip": "Přeskočit",
            "next": "Další",
            "intro_gate": {
                "title": "Přihlas se a pokračuj",
                "body": "Přihlas se nebo si vytvoř účet a Procrastiq se začne přizpůsobovat tomu, co tě baví.",
                "body_more": "Nebude ti zbytečně opakovat stejné otázky, zapamatuje si tvoje výsledky a nabídne ti obsah podle tvých zájmů.",
                "perks": "Navíc získáš přístup k XP, ligám, Survivalu, výzvám s ostatními hráči a dalším funkcím.",
                "register": "Vytvořit účet",
                "login": "Přihlásit se"
            }
        }
    },
    "categories": {
        "title": "Kategorie",
        "filter": "Filtrovat podle kategorie",
        "all": "Vše",
        "loading": "Načítám kategorie...",
        "empty": "Žádné kategorie",
        "expand": "Rozbalit podkategorie",
        "collapse": "Sbalit podkategorie"
    },
    "tags": {
        "title": "Tagy",
        "all": "Vše",
        "loading": "Načítám tagy...",
        "empty": "Žádné tagy"
    },
    "bookmarks": {
        "title": "Uložený obsah",
        "empty": "Zatím nemáte uložený obsah."
    },
    "contribute": {
        "title": "Přispět",
        "subtitle": "Odešlete kvízy ke schválení. Po schválení se objeví ve feedu.",
        "subtitle_reliable": "Jste spolehlivý přispěvatel — vaše kvízy se publikují ihned.",
        "add": "+ Odeslat kvíz",
        "add_first": "Odeslat první kvíz",
        "empty": "Zatím jste neodeslali žádný obsah.",
        "load_failed": "Nepodařilo se načíst váš obsah",
        "cannot_edit_approved": "Schválený obsah může upravit pouze admin.",
        "delete_confirm": "Smazat „{{title}}“?",
        "deleted": "Obsah smazán",
        "delete_failed": "Nepodařilo se smazat obsah",
        "edit": "Upravit",
        "delete": "Smazat",
        "form": {
            "submit_title": "Odeslat kvíz",
            "edit_title": "Upravit kvíz",
            "submit_button": "Odeslat ke schválení",
            "save_button": "Uložit změny",
            "hint": "Váš kvíz bude před zveřejněním ve feedu zkontrolován. Spolehlivým přispěvatelům se publikuje ihned.",
            "success_updated": "Obsah byl úspěšně aktualizován",
            "success_published": "Obsah byl úspěšně publikován",
            "success_submitted": "Obsah byl odeslán ke schválení",
            "success_created": "Obsah byl úspěšně vytvořen",
            "success_translation": "Překlad byl úspěšně vytvořen",
            "failed": "Nepodařilo se {{action}} obsah",
            "action_update": "aktualizovat",
            "action_create": "vytvořit",
            "choose_translation_language": "Vyberte jazyk překladu.",
            "admin_add": "Přidat obsah",
            "admin_edit": "Upravit obsah",
            "admin_add_translation": "Přidat překlad",
            "admin_add_translation_lang": "Přidat překlad ({{lang}})",
            "admin_create": "Vytvořit obsah",
            "admin_update": "Aktualizovat obsah",
            "admin_create_translation": "Vytvořit překlad"
        }
    },
    "content_form": {
        "title": "Název",
        "question": "Otázka",
        "question_placeholder": "Napište celý text otázky",
        "slug": "Slug",
        "language": "Jazyk",
        "difficulty": "Obtížnost (1–5)",
        "country": "Země",
        "status": "Stav",
        "visibility": "Viditelnost",
        "categories": "Kategorie",
        "category": "Kategorie",
        "choose_category": "Vyberte kategorii",
        "tags": "Štítky",
        "translations": "Překlady",
        "translation_new": "(nový)",
        "translate_hint": "Přeložte otázku, možnosti a vysvětlení. Metadata (obtížnost, kategorie, štítky) se zkopírují ze zdroje.",
        "choose_language": "Vyberte jazyk",
        "not_set": "Nenastaveno",
        "options": "Možnosti",
        "option_n": "Možnost {{n}}",
        "correct_answer": "Správná odpověď",
        "explanation": "Vysvětlení",
        "explanation_placeholder": "Volitelné — zobrazí se po špatné odpovědi"
    },
    "user_stats": {
        "title": "Vaše statistiky",
        "sign_in_prompt": "Přihlaste se pro zobrazení statistik",
        "guest_title": "Sbírej XP. Leveluj. Stoupej v ligách.",
        "guest_lead": "Po přihlášení sleduj XP, odemykej hodnosti a soutěž v týdenních ligách.",
        "guest_perk_level": "Získávej XP z kvízů a stoupej po úrovních.",
        "guest_perk_rank": "Odemykej hodnosti podle své úrovně.",
        "guest_perk_league": "Zapoj se do týdenních skupin a postupuj až k Legendární.",
        "xp": "XP",
        "streak": "Série",
        "best_streak": "Nejlepší série",
        "solved": "Odpovězeno",
        "correct": "Správně",
        "accuracy": "Přesnost",
        "bookmarks": "Záložky",
        "contribute": "Přispět",
        "likes": "Lajky",
        "language_mastered": "Zvládnuto",
        "language_learning": "Probíhá",
        "last_7_days": "Posledních 7 dní",
        "days_suffix": "d",
        "no_activity": "Zatím žádná aktivita",
        "weekly_league": "Týdenní liga",
        "league_tiers": "Ligové úrovně",
        "league_tiers_hint": "Úrovně od nejnižší po nejvyšší. Nejlepší ve skupině postupují, nejhorší sestupují.",
        "league_position": "#{{position}} z {{total}} tento týden",
        "view_leaderboard": "Celý žebříček",
        "how_leagues_work": "Jak to funguje",
        "you": "Ty"
    },
    "gamification": {
        "level": "Úroveň",
        "rank": "Hodnost",
        "streak": "Série",
        "daily_goals": "Denní cíle",
        "achievements": "Úspěchy",
        "leaderboard": "Žebříček",
        "season": "Sezóna",
        "xp_to_next": "{{current}} / {{next}} XP do další úrovně",
        "weekly": "Týdenní",
        "monthly": "Tento měsíc",
        "overall": "Celkově",
        "monthly_hint": "Řadí hráče podle soutěžního XP získaného v aktuální měsíční sezóně (stejné klesající výnosy jako u týdenních lig). Není to samostatná ligová úroveň.",
        "overall_hint": "Žebříček podle trvalého celkového XP.",
        "overall_empty": "Na celkovém žebříčku zatím nikdo není.",
        "players": "členů",
        "full_board": "Celý žebříček",
        "player": "Člen",
        "ranked_xp": "Soutěžní XP",
        "total_xp": "Celkové XP",
        "standing": "Postavení",
        "zone": "Postavení",
        "zone_promotion": "Postup",
        "zone_safe": "Bezpečně",
        "zone_relegation": "Sestup",
        "zone_legend": "Nejlepších {{promo}} postupuje · nejhorších {{releg}} sestupuje na konci týdne.",
        "unlocked": "Odemčeno",
        "achievements_error": "Nepodařilo se načíst úspěchy",
        "achievements_intro": "Odemykáte odznaky za hraní — aktivitu, přesnost, série, obtížnost a učení z chyb.",
        "achievement_categories": {
            "activity": "Aktivita",
            "correct_answers": "Správné odpovědi",
            "learning_from_mistakes": "Učení z chyb",
            "streaks": "Série",
            "difficulty": "Obtížnost",
            "variety": "Rozmanitost",
            "general": "Obecné"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Po špatné odpovědi se kvíz může později vrátit k procvičení. Teprve správná odpověď při tom opakování se počítá sem."
        },
        "your_rank": "Tvoje pozice",
        "around_you": "Kolem tebe",
        "tooltip_total_xp": "{{xp}} XP",
        "tooltip_level": "Úroveň {{level}}",
        "weekly_waiting": "Nepodařilo se načíst týdenní skupinu. Zkus to prosím znovu.",
        "weekly_ineligible": "Hraj dál a odemkni týdenní ligy.",
        "achievements_progress": "{{unlocked}} / {{total}} odemčeno",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Úspěch odemčen: {{name}}"
        },
        "level_up": {
            "title": "Nová úroveň!",
            "body": "Dosáhl jsi úrovně {{level}}",
            "continue": "Pokračovat"
        }
    },
    "creator": {
        "rank": "Tvůrčí hodnost",
        "xp": "Tvůrčí XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Schválené příspěvky",
        "views": "Zobrazení",
        "completions": "Dokončení",
        "likes": "Lajky",
        "bookmarks": "Záložky",
        "top_contribution": "Nejlepší příspěvek",
        "newest_contribution": "Nejnovější příspěvek",
        "to_next": "do další hodnosti",
        "players_board": "Členové",
        "creators_board": "Přispěvatelé",
        "board_group": "Typ žebříčku",
        "weekly": "Týdenní",
        "monthly": "Měsíční",
        "all_time": "Celkově",
        "weekly_hint": "Tvůrci podle tvůrčího XP získaného tento týden.",
        "monthly_hint": "Tvůrci podle tvůrčího XP získaného tento měsíc.",
        "all_time_hint": "Žebříček podle celkového tvůrčího XP.",
        "empty": "Na tvůrčím žebříčku zatím nikdo není."
    },
    "profile": {
        "title": "Můj profil",
        "edit": {
            "title": "Upravit profil"
        },
        "nav": {
            "label": "Účet",
            "overview": "Přehled",
            "stats": "Statistiky",
            "leagues": "Ligy",
            "edit": "Upravit profil",
            "contribute": "Přispět",
            "bookmarks": "Záložky",
            "achievements": "Úspěchy",
            "leaderboards": "Žebříčky",
            "browse": "Procházet obsah"
        },
        "actions": {
            "back_to_home": "Zpět na úvod",
            "back_to_profile": "Zpět na profil",
            "edit": "Upravit profil",
            "contribute": "Přispět"
        },
        "labels": {
            "initials": "Iniciály",
            "role": "Role",
            "status": "Stav",
            "sign_in_method": "Způsob přihlášení",
            "member_since": "Členem od",
            "country": "Země",
            "reliable": "Spolehlivý přispěvatel"
        },
        "sections": {
            "account_info": "Informace o účtu",
            "authentication": "Ověření",
            "creator": "Tvůrce",
            "stats": "Tvoje statistiky",
            "leagues": "Týdenní ligy"
        },
        "stats": {
            "title": "Statistiky",
            "subtitle": "Tvůj postup, aktivita a týdenní liga na jednom místě.",
            "empty": "Zatím žádné statistiky. Zahraj pár kvízů a začni.",
            "periods": "Dnes a tento týden",
            "today": "Dnes",
            "see_all": "Všechny statistiky",
            "see_leagues": "Otevřít stránku lig"
        },
        "leagues": {
            "title": "Ligy",
            "subtitle": "Tvoje týdenní ligová úroveň, pozice ve skupině a zóna postupu nebo sestupu.",
            "your_group": "Tvoje skupina tento týden",
            "see_all": "Otevřít ligy"
        }
    },
    "notifications": {
        "title": "Notifikace",
        "hint": "Dostávej upozornění na sérii, pozici v lize a svůj obsah — i když je Procrastiq zavřený.",
        "enable": "Zapnout notifikace",
        "disable": "Vypnout na tomto zařízení",
        "enabled": "Notifikace zapnuty",
        "disabled": "Notifikace na tomto zařízení vypnuty",
        "enable_failed": "Notifikace se nepodařilo zapnout",
        "disable_failed": "Notifikace se nepodařilo vypnout",
        "prefs_failed": "Nastavení se nepodařilo uložit",
        "unsupported": "Tento prohlížeč nepodporuje push notifikace.",
        "pref_ranking": "Liga a žebříček",
        "pref_streak": "Série",
        "pref_reactions": "Reakce na můj obsah",
        "pref_approved": "Schválení obsahu"
    },
    "games": {
        "challenge_friend": "Vyzvi kamaráda",
        "survival_mode": "Survival",
        "challenges_inbox": "Výzvy",
        "view_inbox": "Přehled výzev",
        "pick_friend": "Vyber kamaráda",
        "random_opponent": "Náhodný soupeř",
        "search_users": "Hledej podle jména…",
        "search_error": "Vyhledávání uživatelů selhalo",
        "selected": "Vybráno",
        "selected_opponent": "Vybraný hráč",
        "pick_opponent": "Nejdřív vyber soupeře",
        "random_hint": "Spárujeme tě s aktivním hráčem.",
        "any_category": "Libovolná kategorie",
        "category_optional": "Kategorie (volitelné)",
        "start_challenge": "Odeslat výzvu",
        "challenge_created": "Výzva odeslána!",
        "create_error": "Výzvu se nepodařilo vytvořit",
        "challenge": "Výzva",
        "open": "Otevřít",
        "new_challenge": "Nová výzva",
        "start_playing": "Začít hrát",
        "accept_play": "Přijmout a hrát",
        "decline": "Odmítnout",
        "decline_error": "Výzvu se nepodařilo odmítnout",
        "your_result": "Tvůj výsledek",
        "opponent_result": "Soupeř",
        "waiting_opponent": "Čeká se, až soupeř dokončí…",
        "score_line": "{{correct}}/{{total}} správně · {{time}}",
        "you_won": "Vyhrál jsi!",
        "you_lost": "Prohrál jsi",
        "draw": "Remíza",
        "submitting": "Odesílám odpovědi…",
        "submit_error": "Odeslání výzvy selhalo",
        "load_error": "Načtení selhalo",
        "not_found": "Výzva nenalezena",
        "no_challenges": "Zatím žádné výzvy",
        "incoming": "Příchozí",
        "outgoing": "Odchozí",
        "player": "Hráč",
        "filter": {
            "incoming": "Příchozí",
            "outgoing": "Odchozí",
            "all": "Vše"
        },
        "status": {
            "pending": "Čeká",
            "in_progress": "Probíhá",
            "completed": "Dokončeno",
            "declined": "Odmítnuto",
            "expired": "Vypršelo"
        },
        "question_progress": "Otázka {{current}} / {{total}}",
        "time_left": "{{seconds}} s",
        "elapsed_time": "Čas {{time}}",
        "overall_time": "Celkový čas",
        "total_time_left": "Celkem {{seconds}} s",
        "no_options": "U této otázky nejsou možnosti",
        "survival_leaderboard": "Survival žebříček",
        "survival_leaderboard_hint": "Nejlepší survival run hráče ve zvoleném období.",
        "survival_empty": "Zatím žádné skóre — buď první!",
        "play_survival": "Hrát Survival",
        "current_score": "Skóre: {{score}}",
        "game_over": "Konec hry",
        "final_score": "Skóre: {{score}}",
        "personal_best": "Osobní rekord: {{score}}",
        "daily_rank": "Denní pořadí: #{{rank}}",
        "weekly_rank": "Týdenní pořadí: #{{rank}}",
        "play_again": "Hrát znovu",
        "survival_start_error": "Survival se nepodařilo spustit",
        "survival_error": "Chyba Survival módu",
        "daily": "Denně",
        "weekly": "Týdně",
        "all_time": "Celkově",
        "score": "Skóre",
        "challenge_user": "Vyzvat {{name}}",
        "login_to_challenge": "Pro výzvu se přihlas",
        "profile_error": "Profil se nepodařilo načíst",
        "profile_not_found": "Hráč nenalezen",
        "profile": "Profil",
        "notifications": "Notifikace",
        "mark_all_read": "Označit vše jako přečtené",
        "no_notifications": "Žádné notifikace",
        "blocked_users": "Blokovaní hráči",
        "blocked_hint": "Blokovaní hráči tě nemohou vyzvat.",
        "no_blocked": "Nikoho nemáš zablokovaného.",
        "unblock": "Odblokovat",
        "unblocked": "Hráč odblokován",
        "unblock_error": "Odblokování selhalo",
        "blocked_load_error": "Seznam blokovaných se nepodařilo načíst",
        "survival_howto": "Odpovídej správně co nejdéle. Na každou otázku máš 20 sekund. Jednu špatnou odpověď ti odpustíme — druhá chyba hru ukončí. Skóre je počet správných odpovědí.",
        "challenge_howto": "Deset otázek, na každou 20 sekund. Čím víc správných odpovědí a čím rychleji, tím lépe. Soupeřův výsledek uvidíš, až budete hotoví oba.",
        "continue": "Pokračovat",
        "survival_reserve": "Rezerva: {{count}}",
        "survival_second_chance": "Ještě jedna šance!",
        "guest_teaser": "Přihlas se a vyzývej kamarády nebo hraj Survival."
    },
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Chytré přestávky pro váš mozek"
    }
};
